import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconError = /*@__PURE__*/ proxyCustomElement(class WppIconError extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-danger-color-400)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-error", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.7218 2.22501L17.7459 8.1512C18.74 9.12923 18.7526 10.7275 17.7757 11.7216L11.8486 17.746C10.8706 18.7399 9.27208 18.7529 8.27817 17.775L2.25401 11.8484C1.26007 10.8704 1.24714 9.27193 2.22501 8.27803L8.15136 2.25399C9.12931 1.26006 10.7279 1.24716 11.7218 2.22501ZM10 5.04126C10.5523 5.04126 11 5.48898 11 6.04126V11.0413C11 11.5935 10.5523 12.0413 10 12.0413C9.44772 12.0413 9 11.5935 9 11.0413V6.04126C9 5.48898 9.44772 5.04126 10 5.04126ZM11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-error-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-error", "wpp-icon-error-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-error-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-error-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconError);
      }
      break;
  } });
}

export { WppIconError as W, defineCustomElement as d };
